import React, { useEffect, useRef, useState } from 'react';
import { getUploadUrl } from '../utils/uploadUrl';

const BannerImageField = ({
  existingUrl,
  selectedFile,
  onFileSelect,
  onRemove,
  inputRef,
  removeLabel = 'Remove banner',
  disabled = false
}) => {
  const internalRef = useRef(null);
  const fileRef = inputRef || internalRef;
  const [localPreview, setLocalPreview] = useState(null);

  useEffect(() => {
    if (!selectedFile) {
      setLocalPreview(null);
      return undefined;
    }
    const url = URL.createObjectURL(selectedFile);
    setLocalPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [selectedFile]);

  const displayUrl = localPreview || (existingUrl ? getUploadUrl(existingUrl) : null);

  const handleFileChange = (e) => {
    onFileSelect(e.target.files?.[0] || null);
  };

  const handleReplaceClick = () => {
    if (fileRef.current) {
      fileRef.current.value = '';
      fileRef.current.click();
    }
  };

  return (
    <div className="banner-image-field">
      {displayUrl && (
        <div className="banner-preview" style={{ marginBottom: '12px' }}>
          <img
            src={displayUrl}
            alt="Banner preview"
            style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px' }}
          />
        </div>
      )}
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileRef}
        disabled={disabled}
        style={displayUrl ? { display: 'none' } : undefined}
      />
      {displayUrl ? (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={handleReplaceClick}
            disabled={disabled}
          >
            Replace
          </button>
          {onRemove && (
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={onRemove}
              disabled={disabled}
            >
              {removeLabel}
            </button>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default BannerImageField;
